import {createOidcAuth, SignInType} from "vue-oidc-client/vue2";

const appRootUrl =
  window.location.protocol + "//" + window.location.host + '/';

let oidcConfig = {
  authority: process.env.MIX_AUTH_URL,
  client_id: process.env.MIX_XDEALER_CLIENT_ID,
  response_type: "code",
  scope: process.env.MIX_XDEALER_CLIENT_SCOPE || 'openid profile',
  post_logout_redirect_uri: window.location.protocol + "//" + window.location.host
};

const mainOidc = createOidcAuth("dealer", SignInType.Window, appRootUrl, oidcConfig);

mainOidc.events.addUserSignedIn(() => {
  console.log("[AUTH] signed in");
});

// handle events
mainOidc.events.addAccessTokenExpiring(function () {
  mainOidc.startSilentRenew();
});

mainOidc.events.addAccessTokenExpired(function () {
  mainOidc.startSilentRenew();
});

mainOidc.events.addSilentRenewError(function (err) {
  console.log("[AUTH] Silent Renew Error", err);
  mainOidc.signIn();
});

mainOidc.events.addUserLoaded(function (user) {
  console.log("[AUTH] User Loaded", user);
});

mainOidc.events.addUserUnloaded(function () {
  console.log("[AUTH] User Unloaded");
});

mainOidc.events.addUserSignedOut(function () {
  console.log("[AUTH] User SignOut");
});

mainOidc.events.addUserSessionChanged(function () {
  console.log("[AUTH] user session changed");
});

export default mainOidc;
